import { useTheme } from '@/contexts/ThemeContext';
import { Construction } from 'lucide-react';

interface ComingSoonProps {
  title: string;
  description?: string;
}

export const ComingSoon = ({ title, description }: ComingSoonProps) => {
  const { theme } = useTheme();
  
  return (
    <div className="flex items-center justify-center min-h-[60vh]" style={{ backgroundColor: theme.colors.bgPage }}>
      <div 
        className="text-center p-12 rounded-lg border max-w-md"
        style={{ 
          backgroundColor: theme.colors.bgCard,
          borderColor: theme.colors.borderColor
        }}
      >
        <Construction 
          size={64} 
          className="mx-auto mb-4" 
          style={{ color: theme.colors.primaryColor }} 
        />
        <h2 
          className="text-2xl font-bold mb-2"
          style={{ color: theme.colors.textPrimary }}
        >
          {title}
        </h2>
        {description && (
          <p style={{ color: theme.colors.textSecondary }}>
            {description}
          </p>
        )}
        <p 
          className="text-sm mt-4"
          style={{ color: theme.colors.textTertiary }}
        >
          This feature is under development and will be available soon.
        </p>
      </div>
    </div>
  );
};
